import React, {useEffect, useState} from 'react'
import {TransactionStatusItem} from './TransactionStatusItem'
import {dayMonthYearAtTimeWithSeconds} from '../../utils/dates'
import Loading from '../../component/Loading/Loading'
import { Row } from 'react-bootstrap'

export const TransanctionStatusContainer = ({transactionData}) => {

  if (!transactionData) {
    return <Loading/>
  }

  const [statusData, setStatusData] = useState(null)

  const sumTotalItems = () => {
    let total = 0
    transactionData && transactionData.items.forEach(x => total += x.quantity)
    return total
  }

  useEffect(() => {
    const data = [];
    data.push({title: 'ID da operação', icon: 'code fa-lg', content: transactionData.id.substr(-6)});
    data.push({title: 'Data/hora Inicio', icon: 'history fa-lg', content: dayMonthYearAtTimeWithSeconds(transactionData.createdAt)});
    data.push({title: 'Operador', icon: 'user-circle fa-lg', content: transactionData.username});
    transactionData.movementOrder && transactionData.movementOrder["tipoRota" && "operacao"] && data.push({title: 'Tipo de rota/operação', icon: 'road fa-lg', content: `${transactionData.movementOrder.tipoRota} / ${transactionData.movementOrder.operacao}`});
    transactionData.movementOrder && transactionData.movementOrder.rota && data.push({title: 'Rota', icon: 'road fa-lg', content: transactionData.movementOrder && transactionData.movementOrder.rota});
    data.push({title: 'Local Destino', icon: 'map fa-lg', content: transactionData.destination ? transactionData.destination.friendlyName : ''});
    data.push({title: 'Ponto de Controle', icon: 'fa fa-podcast', content: transactionData.checkpoint ? transactionData.checkpoint.friendlyName : ''});
    transactionData.movementOrder && data.push({title: 'Código do Romaneio', icon: 'far fa-clipboard', content: transactionData.movementOrder ? transactionData.movementOrder.code : ''});
    data.push({title: 'Total de itens', icon: 'archive fa-lg', content: sumTotalItems()});
    setStatusData(data)
  }, [transactionData])

  return (
      <Row className="d-flex align-items-center justify-content-start w-100">
        {
          !statusData ? <Loading/> : statusData.map((item, index) => <TransactionStatusItem key={index} title={item.title} icon={item.icon} content={item.content}/>)
        }
      </Row>
  )
}



// WEBPACK FOOTER //
// ./src/component/Transaction/TransactionStatusContainer.js